// extracted by mini-css-extract-plugin
export default {"main":"ObjetivoAlumnoSelector_main__0DtX+"};